import { defineMessages } from 'react-intl';

import type { PageStatusFilterValueKey } from '../../../../../common/constants/filters/page-status-filter';

export const pageStatusLabels: Record<
	'all' | PageStatusFilterValueKey,
	import('react-intl').MessageDescriptor
> = defineMessages<PageStatusFilterValueKey | 'all'>({
	all: {
		id: 'search-page.filter.pageStatus.all',
		defaultMessage: 'All',
		description:
			'Drop-down item label for the All option in the Page Status filter, meaning no status filter is applied.',
	},
	roughDraft: {
		id: 'search-page.filter.pageStatus.roughDraft',
		defaultMessage: 'Rough draft',
		description:
			'Drop-down item label for the Rough Draft option in the Confluence Page Status filter on the search page.',
	},
	inProgress: {
		id: 'search-page.filter.pageStatus.inProgress',
		defaultMessage: 'In progress',
		description:
			'Drop-down item label for the In Progress option in the Confluence Page Status filter on the search page.',
	},
	readyForReview: {
		id: 'search-page.filter.pageStatus.readyForReview',
		defaultMessage: 'Ready for review',
		description:
			'Drop-down item label for the Ready For Review option in the Confluence Page Status filter on the search page.',
	},
	verified: {
		id: 'search-page.filter.pageStatus.verified',
		defaultMessage: 'Verified',
		description:
			'Drop-down item label for the Verified option in the Confluence Page Status filter on the search page.',
	},
});
